import { useState, type FormEvent } from "react";
import { useNavigate } from "react-router-dom";

interface SearchBarProps {
  defaultValue?: string;
  size?: "sm" | "lg";
}

export default function SearchBar({ defaultValue = "", size = "sm" }: SearchBarProps) {
  const [value, setValue] = useState(defaultValue);
  const navigate = useNavigate();

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const keyword = value.trim();
    navigate(keyword ? `/search?query=${encodeURIComponent(keyword)}` : "/search");
  };

  if (size === "lg") {
    return (
      <form onSubmit={handleSubmit} className="w-full" role="search">
        <div className="flex flex-col sm:flex-row items-stretch bg-background-50 rounded-xl sm:rounded-full border border-background-200 p-1.5 gap-1.5">
          <div className="flex items-center flex-1 px-4 gap-2.5">
            <span className="w-5 h-5 flex items-center justify-center text-foreground-400 shrink-0">
              <i className="ri-search-line text-lg" />
            </span>
            <input
              type="search"
              name="query"
              value={value}
              onChange={(e) => setValue(e.target.value)}
              placeholder="输入网站名称或关键词，如：招聘、视频、学习……"
              className="w-full bg-transparent outline-none text-sm text-foreground-900 placeholder:text-foreground-400 py-3"
            />
          </div>
          <button
            type="submit"
            className="px-7 py-3 rounded-xl sm:rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium whitespace-nowrap transition-colors cursor-pointer"
          >
            搜索网址
          </button>
        </div>
      </form>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="w-full" role="search">
      <div className="flex items-center bg-background-100 hover:bg-background-200/70 border border-background-200 rounded-full pl-3.5 pr-1 py-1 gap-2 transition-colors">
        <span className="w-4 h-4 flex items-center justify-center text-foreground-400 shrink-0">
          <i className="ri-search-line text-base" />
        </span>
        <input
          type="search"
          name="query"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder="搜索网址"
          className="flex-1 min-w-0 bg-transparent outline-none text-sm text-foreground-900 placeholder:text-foreground-400 py-1.5"
        />
        <button
          type="submit"
          className="px-3.5 py-1.5 rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 text-xs font-medium whitespace-nowrap transition-colors cursor-pointer"
        >
          搜索
        </button>
      </div>
    </form>
  );
}